import { render, staticRenderFns } from "./EpilepsyQuestionnaire.vue?vue&type=template&id=cdc5cf8a&"
import script from "./EpilepsyQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./EpilepsyQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports